import React from 'react'
import { Icon } from 'semantic-ui-react'

import { getAProduct } from '../../redux/actions/products'
import { Mode } from '../../redux/types/ui'

interface Props {
  gettingProductId: number | undefined
  lastAction: Mode
  dispatch: any
  row: any
}

export const TableCellCopy = (props: Props) => {
  const { gettingProductId, dispatch, row, lastAction } = props
  return (
    <Icon
      link
      disabled={gettingProductId != null}
      loading={lastAction === 'clipboard' && gettingProductId === row.values.id}
      name={
        lastAction === 'clipboard' && gettingProductId === row.values.id
          ? 'spinner'
          : 'copy outline'
      }
      color="grey"
      onClick={() => {
        dispatch(getAProduct({ productId: row.values.id, mode: 'clipboard' }))
      }}
    />
  )
}
